import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferTokenService {

  private URL = environment.api + "api/erp/transferToken";
  constructor(
    private http: HttpClient
  ) { }

  createTokenTransfer() {
    return this.http.post(this.URL + "/create", {});
  }
}
